// =====================================
//
//   更改商品 Modal
//   Author: Gray
//   createtime: 2016 / 04 / 13
//   updatetime: 2016 / 04 / 13
//
// =====================================

window.InifECApp.directive('changeOrderitem', ['$rootScope', '$ngModal', '$timeout', 'ProductService', '$ProductFormatService',
	function ($rootScope, $ngModal, $timeout, ProductService, $ProductFormatService) {

		var _dir = {};

		var link = function(scope, element, attrs) {}

		var controller = ['$scope', '$element', function($scope, $element) {

			var openModal = function() {

				$ngModal.openModal("change-orderitem-modal");
				$element.find('.content').scrollTop(0);
			}

			var closeModal = function() {

				$ngModal.closeModal("change-orderitem-modal");
			}

			var getPdtClassList = function(orderitem) {

				if($scope.isLoading || $scope.isLoaded) {
					return;
				}

            	$scope.isLoading = true;
	            ProductService.getPdtClassList().then(function(result) {
	                if(result) {

	                	$scope.pdtClassList = $ProductFormatService.getPdtClassList('MODAL');

	                	if(!$scope.pdtClassList || $scope.pdtClassList.length == 0) {
	                		var _result = shallowCopy(result);

	                    	$scope.pdtClassList = $ProductFormatService.formatModalPdtClassList(_result);
	                    }
	                    getPdtClassListSuccess(orderitem);
	                }

	                $scope.isLoaded = true;
	                $scope.isLoading = false;
	            }, function(error) {
	                $scope.isLoading = false;
	                $scope.isError = true;
	            });
	        }

	        var getPdtClassListSuccess = function(orderitem) {

	        	if($scope.pdtClassList.length > 0) {
	        		getOrderItem(orderitem);
	        	}
	        }

	        var getOrderItem = function(orderitem) {

                for(var i = 0; i < $scope.pdtClassList.length; i++) {

                    var mainPdtClass = $scope.pdtClassList[i];

                    for(var j = 0; j < mainPdtClass.pdtClasses.length; j++) {

                        var pdtClass = mainPdtClass.pdtClasses[j];

                        if(orderitem.pdtClass == pdtClass.pdtClass) {

                            // 複合商品找法不同
                            if(orderitem.complexidList && orderitem.complexidList.length > 0) {
                                if(getComplexOrderItem(orderitem, mainPdtClass, pdtClass)) {
                                	return;
                                }
                            } else {
                                for(var k = 0; k < pdtClass.products.length; k++) {
                                    var product = pdtClass.products[k];
                                    if(orderitem.productid == product.productid) {
                                        $scope.form.mainPdtClass = mainPdtClass;
                                        $scope.form.pdtClass = pdtClass;
                                        $scope.form.product = product;
                                        return;
                                    }
                                }
                            }                            
                        }
                    }
                }
            }

            var getComplexOrderItem = function(orderitem, mainPdtClass, pdtClass) {

                for(var i = 0; i < pdtClass.products.length; i++) {
                    var product = pdtClass.products[i];

                    if(product.complex && product.complex.productList && product.complex.productList.length > 0) {
                        for(var j = 0; j <  product.complex.productList.length; j++) {
                            var complexPdt = product.complex.productList[j];
                            if(orderitem.productid == complexPdt.productid) {
                                $scope.form.mainPdtClass = mainPdtClass;
                                $scope.form.pdtClass = pdtClass;
                                
                                var _product = shallowCopy(product);

                                complexPdt.name = _product.name;
                                complexPdt.complex = _product.complex;
                                complexPdt.isComplex = _product.isComplex;

                                $scope.form.product = complexPdt;
                                return true;
                            }
                        }
                    }
                }

                return false;
            }

            var changeMainPdtClass = function(mainPdtClass){
            	if($scope.form.mainPdtClass == mainPdtClass){
            		return;
            	}

            	$scope.form.mainPdtClass = mainPdtClass;
            	changePdtClass(mainPdtClass.pdtClasses[0]);
            }

            var changePdtClass = function(pdtClass) {
            	if($scope.form.pdtClass == pdtClass) {
            		return;
            	}

            	$scope.form.pdtClass = pdtClass;
            	changeProduct(pdtClass.products[0]);
            }

            var changeProduct = function(product) {
            	if($scope.form.product == product) {
            		return;
            	}

            	$scope.form.product = product;
            }

			var init = function(orderitem) {
				if($scope.isLoaded){
					getOrderItem(orderitem);
					return;
				}

				getPdtClassList(orderitem);
			}
			
			//==========================
	        //  Events
	        //==========================
	        $scope.$on("OPEN_CHANGE_ORDERITEM_MODAL", function(event, data) {
	        	if(data) {
	        		$scope.orderitem = data.orderitem;
	        		$scope.callback = data.callback;

	        		init($scope.orderitem);
	        		openModal();
	        	}
			});


			$scope.$on("ON_CHANGE_ORDERITEM_SUCCESS", function(event, data){
				if(data) {
					if(typeof $scope.callback == "function") {
						($scope.callback) && $scope.callback(data.orderitem);
					}

	                closeModal();
				}
			});

	        //==========================
	        //  Members
	        //==========================
	        $scope.isLoading = false;
	        $scope.isLoaded = false;
	        $scope.pdtClassList = [];
	        $scope.orderitem = undefined;
	        $scope.form = {
	        	mainPdtClass: undefined,
	        	pdtClass: undefined,
	        	product: undefined
	        };

	        //==========================
	        //  Methods
	        //==========================
	        $scope.changeMainPdtClass = changeMainPdtClass;
	        $scope.changePdtClass = changePdtClass;
	        $scope.changeProduct = changeProduct;
	        $scope.callback;

	        //==========================
	        //  Init
	        //==========================


		}]

		_dir.scope = true;
		_dir.restrict = 'E';
		_dir.templateUrl = 'partials/modal/change_orderitem.html';
		_dir.link = link;
		_dir.controller = controller;
		
		return _dir;

	}
]);